export default [
  { text: '3 meses', value: 3},
  { text: '6 meses', value: 6},
  { text: '9 meses', value: 9},
  { text: '12 meses', value: 12},
  { text: '15 meses', value: 15},
  { text: '18 meses', value: 18},
  { text: '21 meses', value: 21},
  { text: '24 meses', value: 24},
]